import { render, staticRenderFns } from "./GoodsDetailsItemRow.vue?vue&type=template&id=e5eb9b40"
import script from "./GoodsDetailsItemRow.vue?vue&type=script&lang=js"
export * from "./GoodsDetailsItemRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports